module.exports = "/_next/static/images/guarantee_revisi_id-f17ff4c0a50985c4381147835e744d24.webp";